module.exports = __webpack_public_path__ + "img/flag_cambodia.952c30ba.png";